module.exports = __webpack_public_path__ + "static/cat-laser-3b720428dc006121a8b925481cf7c835.gif";